import { MAPBOX_USER_ID } from "../constants";
import { WELLS_LAYER_IDS } from "./wells";

/* Shared pieces for the static reference layer modules (faults, plays,
 * basins). */
const SOURCE_ID = "geo_features";

const addSource = (mapRef) => {
  if (!mapRef.current.getSource(SOURCE_ID)) {
    mapRef.current.addSource(SOURCE_ID, {
      type: "vector",
      url: `mapbox://${MAPBOX_USER_ID}.geo_features`,
    });
  }
};

/* Reference layers sit beneath the wells stack: insert before the lowest
 * wells layer present in the style. */
const getAddBefore = (map) => {
  const anchors = new Set(WELLS_LAYER_IDS);
  const found = map.getStyle().layers.find((l) => anchors.has(l.id));
  return found ? found.id : undefined;
};

export { SOURCE_ID, addSource, getAddBefore };
